import { render } from "./Aprender.vue?vue&type=template&id=59030d20&scoped=true"
import script from "./Aprender.vue?vue&type=script&lang=js"
export * from "./Aprender.vue?vue&type=script&lang=js"

import "./Aprender.vue?vue&type=style&index=0&id=59030d20&lang=scss&scoped=true"

import exportComponent from "/Users/bruno/Documents/projects/pixeon-c/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59030d20"]])

export default __exports__